import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NimblePicker } from 'emoji-mart';
import data from 'emoji-mart/data/apple.json';
import _get from 'lodash/get';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './PostDetailCommentForm.module.css';
import CameraIconSelected from 'assets/images/camera-icon-selected@3x.png';
import CameraIconUnselected from 'assets/images/camera-icon@3x.png';
import LeafSelected from 'assets/images/leaf-selected@3x.png';
import LeafUnselected from 'assets/images/leaf-unselected@3x.png';
import Button from 'components/UI/Button/Button';
import RizaResponses from 'containers/UI/RizaResponses/RizaResponses';
import TagSelector from 'containers/UI/Tags/TagSelector/TagSelector';
import TextArea from 'containers/UI/TextArea/TextArea';
import CommentsUppy from 'containers/Uppy/Dashboard/CommentsUppy/CommentsUppy';
import {
  combineAndDedupArrays,
  formatDateForPostDetails,
  formatDateTimeForDisplay,
  getAuthorName,
  getRgbFromColorName,
  updateObject,
  updatedControlsForInput,
} from 'shared/utility';
import * as actions from 'store/actions';
import 'emoji-mart/css/emoji-mart.css';

class PostDetailCommentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      controls: {
        commentText: {
          elementType: 'textarea',
          elementConfig: {
            type: 'textarea',
            initialRows: 1,
            minRows: 1,
            maxRows: 10,
            placeholder: this.props.commentType === 'adminNote' ? 'Admin Notes' : 'Contribute...',
          },
          value: this.props.comment && this.props.commentType === 'editComment' ? this.props.comment.Comment : '',
          validation: {
            required: false,
            validationError: 'Please enter a comment',
          },
          valid: false,
          touched: false,
        },
        images: {
          imageThumbUrls:
            this.props.editImage === true
              ? [this.props.editImageThumbURL]
              : this.props[`${this.props.commentType}Images`].map((image) => _get(image, 'ImageURL', _get(image, 'ThumbURL'))),
          value: this.props.editImage === true ? [this.props.editImageId] : this.props[`${this.props.commentType}Images`].map((image) => image.Id),
          validation: {
            required: false,
            validationError: 'Please add a photo',
          },
          valid: true,
          touched: false,
        },
        whatTags: {
          value: this.props.comment && this.props.comment.Tags && this.props.commentType === 'editComment' ? this.props.comment.Tags.WhatTags : [],
        },
        whoTags: {
          value: this.props.comment && this.props.comment.Tags && this.props.commentType === 'editComment' ? this.props.comment.Tags.WhoTags : [],
        },
        locationTags: {
          value:
            this.props.comment && this.props.comment.Tags && this.props.commentType === 'editComment' ? this.props.comment.Tags.LocationTags : [],
        },
      },
      renderedSelector: this.props.comment && this.props.comment.Tags ? 'showTagsSelector' : null,
      // showFileTypeError: false,
      formIsValid: false,
      touched: false,
      skinTone: _get(this.props, `emojiSkinTone.${this.props.postingAs.UserId}`, 1),
    };
  }

  componentDidMount() {
    if (!this.props.tags.loaded) this.props.onFetchTags();
    // if(this.props.comment && this.props.comment.Tags) this.setState({renderedSelector: 'showTagsSelector' })
  }

  componentDidUpdate(prevProps) {
    // Handling updating view when images are successfully uploaded
    if (this.props[`${this.props.commentType}Images`] !== prevProps[`${this.props.commentType}Images`] && this.props.imagesUpdated === true) {
      const updatedControls = updateObject(this.state.controls, {
        images: updateObject(this.state.controls.images, {
          value:
            this.props[`${this.props.commentType}Images`].length > 0 ? this.props[`${this.props.commentType}Images`].map((image) => image.Id) : [],
          imageThumbUrls:
            this.props[`${this.props.commentType}Images`].length > 0
              ? this.props[`${this.props.commentType}Images`].map((image) => _get(image, 'ImageURL', _get(image, 'ThumbURL')))
              : [],
          valid: true,
          touched: true,
        }),
      });
      const formIsValid = this.formIsValid(updatedControls);
      this.setState({ controls: updatedControls, formIsValid });
    }
  }

  formIsValid = (updatedControls) => {
    let formIsValid = false;
    Object.keys(updatedControls).forEach((controlName) => {
      if (updatedControls[controlName].value.length > 0) formIsValid = true;
    });
    return formIsValid;
  };

  inputChangedHandler = (event, controlName) => {
    if (event.target.value !== '\n') {
      const updatedControls = updatedControlsForInput(event.target.value, controlName, this.state.controls);
      const formIsValid = this.formIsValid(updatedControls);
      const touched = !!(this.state.touched || event.target.value.length > 0);
      this.setState({ controls: updatedControls, formIsValid, touched });
    }
  };

  resetCommentForm = () => {
    const updatedControls = updateObject(this.state.controls, {
      commentText: updateObject(this.state.controls.commentText, {
        value: '',
      }),
      whatTags: { value: [] },
      whoTags: { value: [] },
      locationTags: { value: [] },
    });
    this.setState({ controls: updatedControls, formIsValid: false, touched: false });
  };

  cancelComment = () => {
    this.props.toggleContributeForm();
    this.resetCommentForm();
  };

  handleInputKeyDown = (evt) => {
    if (evt.keyCode === 13 && !evt.shiftKey) {
      if (this.state.formIsValid === true) {
        this.submitComment();
      }
    }
  };

  toggleComponent = (componentName) => {
    const renderedComponent = this.state.renderedSelector === componentName ? null : componentName;
    this.setState({ renderedSelector: renderedComponent });
  };

  submitComment = () => {
    const commentText = this.state.controls.commentText.value.length > 0 ? this.state.controls.commentText.value : null;
    const commentImages = this.state.controls.images.value.length > 0 ? this.state.controls.images.value : null;
    const parentCommentId = this.props.parentCommentId ? this.props.parentCommentId : null;
    const roomId = this.props.roomId ? this.props.roomId : null;
    if (this.props.commentType === 'addComment' || this.props.commentType === 'adminNote') {
      this.props.onSubmitComment(
        this.props.postId,
        this.props.logId,
        this.props.postingAs.UserId,
        this.props.isManagedUser,
        commentText,
        commentImages,
        parentCommentId,
        roomId,
        this.state.controls.whoTags.value,
        this.state.controls.whatTags.value,
        this.state.controls.locationTags.value,
      );
    } else if (this.props.commentType === 'editComment') {
      this.props.onUpdateComment(
        this.props.comment.Id,
        this.state.controls.commentText.value,
        false,
        this.props.isManagedUser,
        this.props.postingAs.UserId,
        this.props.logId,
        this.state.controls.whoTags.value,
        this.state.controls.whatTags.value,
        this.state.controls.locationTags.value,
      );
      this.props.cancelComment();
    } else if (this.props.commentType === 'replyToComment') {
      this.props.onSubmitComment(
        this.props.postId,
        this.props.logId,
        this.props.postingAs.UserId,
        this.props.isManagedUser,
        commentText,
        commentImages,
        parentCommentId,
        roomId,
        this.state.controls.whoTags.value,
        this.state.controls.whatTags.value,
        this.state.controls.locationTags.value,
      );
    }

    this.resetCommentForm();
  };

  addFormContent = (string, isEmoji) => {
    if (isEmoji) console.log(string);
    const content = isEmoji ? string.native : string;
    const updatedControlValue = this.state.controls.commentText.value + content;
    const updatedControls = updatedControlsForInput(updatedControlValue, 'commentText', this.state.controls);
    const formIsValid = this.formIsValid(updatedControls);
    this.setState({ controls: updatedControls, formIsValid });
  };

  /* Comment Image Methods */

  imageUploadHandler = (event) => {
    if (event.target.files[0] && event.target.files[0].type === 'image/jpeg') {
      this.props.onUploadPostImage(event.target.files[0], 'comment', null, this.props.commentType);
    } else {
      this.toggleComponent('showFileTypeError');
    }
  };

  imageDeletionHandler = (index, imageId) => {
    this.props.onPostImageRemoval(index, imageId, 'comment', this.props.commentType);
  };

  handleTagsUpdate = (tagsToBeAdded, tagsToBeRemoved, tagCategory) => {
    let ammendedTagList = combineAndDedupArrays(this.state.controls[tagCategory].value, tagsToBeAdded);
    ammendedTagList = ammendedTagList.filter((tag) => tagsToBeRemoved.includes(tag) === false);
    const updatedControls = updateObject(this.state.controls, {
      [tagCategory]: updateObject(this.state.controls[tagCategory], {
        value: ammendedTagList,
      }),
    });
    const formIsValid = this.formIsValid(updatedControls);
    this.setState({ controls: updatedControls, formIsValid });
  };

  skinToneHandler = (skin) => {
    this.setState({ skinTone: skin });
    const skinTones = JSON.parse(localStorage.getItem('skinTones') || '{}');
    skinTones[this.props.postingAs.UserId] = skin;
    localStorage.setItem('skinTones', JSON.stringify(skinTones));
    this.props.onEditEmojiTone(skinTones);
  };

  render = () => {
    let commentError = null;
    let commentHeader = null;
    let imageSelector = null;
    let emojiSelector = null;
    let rizaResponsesSelector = null;
    let tagSelector = null;
    let commentImages = null;
    const selectorContainerClasses = [classes.SelectorContainer];
    const commentFormContainerClasses = [classes.CommentFormContainer];
    if (this.state.renderedSelector !== null) selectorContainerClasses.push(classes.Shown);
    if (this.props.commentError) {
      commentError = <p className={classes.CommentError}>{this.props.commentError}</p>;
    }
    if (this.props.commentType) commentFormContainerClasses.push(classes[this.props.commentType]);
    if (this.props.shown === false) {
      commentFormContainerClasses.push(classes.Hidden);
    }

    if (this.state.renderedSelector === 'showImageSelector') {
      imageSelector = (
        <div className={classes.UppyContainer}>
          <CommentsUppy close={() => this.toggleComponent('showImageSelector')} commentType={this.props.commentType} />
        </div>
      );
    }

    if (this.state.renderedSelector === 'showRizaResponsesSelector') {
      rizaResponsesSelector = <RizaResponses addResponse={this.addFormContent} />;
    }

    if (this.state.renderedSelector === 'showEmojiSelector') {
      emojiSelector = (
        <div className={classes.EmojiPickerContainer}>
          <NimblePicker
            set="apple"
            data={data}
            onSkinChange={(skin) => this.skinToneHandler(skin)}
            title="Pick skin tone"
            emoji="thumbsup"
            theme="dark"
            skin={this.state.skinTone}
            style={{ backgroundColor: 'transparent', marginBottom: '22px', color: '#707070', border: 'solid 1px #707070', width: '348px' }}
            onSelect={(emoji) => this.addFormContent(emoji, true)}
            defaultSkin={3}
          />
        </div>
      );
    }

    if (this.state.renderedSelector === 'showTagsSelector') {
      tagSelector = (
        <TagSelector
          type="CommentForm"
          tagsLoaded={this.props.tags.loaded}
          whatTagsList={[...this.props.tags.WhatTags].filter((tag) => !this.state.controls.whatTags.value.includes(tag))}
          whoTagsList={[...this.props.tags.WhoTags].filter((tag) => !this.state.controls.whoTags.value.includes(tag))}
          locationTagsList={[...this.props.tags.LocationTags].filter((tag) => !this.state.controls.locationTags.value.includes(tag))}
          selectedWhatTags={this.state.controls.whatTags.value}
          selectedWhoTags={this.state.controls.whoTags.value}
          selectedLocationTags={this.state.controls.locationTags.value}
          tagCategory="whatTags"
          updateTags={this.handleTagsUpdate}
        />
      );
    }

    if (this.state.controls.images.imageThumbUrls.length > 0) {
      commentImages = this.state.controls.images.imageThumbUrls.map((imageURL, i) => (
        <div
          onClick={() => this.props.onPostImageRemoval(i, this.state.controls.images.value[i], 'comment', this.props.commentType)}
          className={classes.ImageHolder}
          key={i}
        >
          <img src={imageURL} className={classes.PostImageThumb} alt={`Post Photo${i}`} />
          <span className={classes.DeleteImage} />
        </div>
      ));
    }

    if (this.props.commentType === 'replyToComment' || this.props.isReply === true) {
      const originalComment = this.props.parentComment ? this.props.parentComment : this.props.comment;
      const replyingTo = (
        <div>
          <span className={classes.CommentReplier} style={{ color: getRgbFromColorName(this.props.postingAs.Color) }}>
            {getAuthorName(this.props.postingAs.NickName, this.props.postingAs.FirstName, this.props.postingAs.LastName)}
          </span>
          <span className={classes.ReplyTo}> reply to </span>
          <span className={classes.CommentAuthor} style={{ color: getRgbFromColorName(originalComment.Color) }}>
            {getAuthorName(originalComment.NickName, originalComment.FirstName, originalComment.LastName)}
          </span>
        </div>
      );

      commentHeader = (
        <div className={classes.CommentHeader}>
          {replyingTo}
          <span className={classes.CommentTimeSince}>{formatDateForPostDetails(new Date())} </span>
          <FontAwesomeIcon icon="times" className={classes.CloseCommentIcon} onClick={this.props.cancelComment} />
        </div>
      );
    } else if (this.props.commentType === 'editComment') {
      commentHeader = (
        <div className={classes.CommentHeader}>
          <span className={classes.CommentAuthor} style={{ color: getRgbFromColorName(this.props.comment.Color) }}>
            {getAuthorName(this.props.comment.NickName, this.props.comment.FirstName, this.props.LastName)}
          </span>
          <span className={classes.CommentTimeSince}>{formatDateTimeForDisplay(this.props.comment.Date, true)}</span>
          <FontAwesomeIcon icon="times" className={classes.CloseCommentIcon} onClick={this.props.cancelComment} />
        </div>
      );
    } else {
      commentHeader = <FontAwesomeIcon icon="times" className={classes.CloseCommentIcon} onClick={this.cancelComment} />;
    }

    return (
      <div className={commentFormContainerClasses.join(' ')}>
        <div className={classes.AddComment}>
          <div className={classes.CommentForm}>
            {commentHeader}

            <TextArea
              value={this.state.controls.commentText.value}
              className="PostDetailComment"
              minRows={1}
              maxRows={6}
              initialRows={this.state.controls.commentText.elementConfig.initialRows}
              placeholder={this.state.controls.commentText.elementConfig.placeholder}
              invalid={!this.state.controls.commentText.valid}
              shouldValidate={this.state.controls.commentText.validation}
              validationError={
                this.state.controls.commentText.validation.required === true ? this.state.controls.commentText.validation.validationError : null
              }
              touched={this.state.controls.commentText.touched}
              changed={(event) => this.inputChangedHandler(event, 'commentText')}
            />
            <div className={classes.CommentImagesContainer}>{commentImages}</div>
            <div className={classes.CommentActions}>
              <div className={classes.CommentFormOptions}>
                <img
                  alt="riza-leaf"
                  src={this.state.renderedSelector === 'showRizaResponsesSelector' ? LeafSelected : LeafUnselected}
                  className={classes.LeafIcon}
                  onClick={() => this.toggleComponent('showRizaResponsesSelector')}
                />
                <img
                  alt="riza-images-icon"
                  src={this.state.renderedSelector === 'showImageSelector' ? CameraIconSelected : CameraIconUnselected}
                  className={classes.CameraIcon}
                  onClick={() => this.toggleComponent('showImageSelector')}
                />
                <FontAwesomeIcon
                  icon={['far', 'smile']}
                  className={
                    this.state.renderedSelector === 'showEmojiSelector' ? [classes.EmojiIcon, classes.Selected].join(' ') : classes.EmojiIcon
                  }
                  onClick={() => this.toggleComponent('showEmojiSelector')}
                />
                <FontAwesomeIcon
                  icon="tags"
                  className={this.state.renderedSelector === 'showTagsSelector' ? [classes.TagsIcon, classes.Selected].join(' ') : classes.TagsIcon}
                  onClick={() => this.toggleComponent('showTagsSelector')}
                />
              </div>
              <Button btnType="SendPostDetailComment" disabled={!this.state.formIsValid} clicked={this.submitComment}>
                {this.props.commentType === 'addComment' || this.props.commentType === 'adminNote'
                  ? 'Send'
                  : this.props.commentType === 'editComment'
                  ? 'Update'
                  : 'Reply'}
              </Button>
            </div>
            {commentError}
            <div className={selectorContainerClasses.join('')}>
              {imageSelector}
              {emojiSelector}
              {tagSelector}
              {rizaResponsesSelector}
            </div>
          </div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    isManagedUser: state.user.postingAs.UserId !== state.user.signedInAs.UserId,
    replyToCommentImages: state.post.replyToComment.images,
    addCommentImages: state.post.addComment.images,
    editCommentImages: state.post.editComment.images,
    adminNoteImages: state.post.adminNote.images,
    imagesUpdated: state.post.imagesUpdated === true,
    postingAs: state.user.postingAs,
    loading: state.post.loading,
    error: state.post.commentError,
    tags: state.logs.Tags,
    emojiSkinTone: state.user.emojiSkinTone,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmitComment: (PostId, LogId, UserId, isManagedUser, Comment, CommentImageId, ParentCommentId, RoomId, WhoTags, WhatTags, LocationTags) =>
      dispatch(
        actions.submitPostComment(
          PostId,
          LogId,
          UserId,
          isManagedUser,
          Comment,
          CommentImageId,
          ParentCommentId,
          RoomId,
          WhoTags,
          WhatTags,
          LocationTags,
        ),
      ),
    onUpdateComment: (CommentId, Comment, Delete, isManagedUser, UserId, LogId, WhoTags, WhatTags, LocationTags) =>
      dispatch(actions.entryCommentUpdate(CommentId, Comment, Delete, isManagedUser, UserId, LogId, WhoTags, WhatTags, LocationTags)),
    onUploadPostImage: (Image, Type, SizeTo, CommentType) => dispatch(actions.uploadPostImage(Image, Type, SizeTo, CommentType)),
    onPostImageRemoval: (index, imageId, type, CommentType) => dispatch(actions.removePostImage(index, imageId, type, CommentType)),
    onFetchTags: () => dispatch(actions.fetchTagsForLogs()),
    onEditEmojiTone: (skinTone) => dispatch(actions.editEmojiTone(skinTone)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PostDetailCommentForm);
